import React from 'react'
import {graphql} from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Layout from '../components/layout'
import Head from '../components/head'

export const query = graphql`
    query($slug:String!) {
        contentfulProjectPost(slug: {eq: $slug}) {
            title
            createdDate(formatString: "MMMM Do, YYYY")
            body {
                json
            }
        }
    }
`
const Proj = (props) => {
    const options = {
        renderNode: {
            "embedded-asset-block": (node) => {
                const alt = node.data.target.fields.title['en-US']
                const url = node.data.target.fields.file['en-US'].url
                return <img alt={alt} src={url}/>
            }
        }
    }

    return (
        <Layout>
            <Head title={props.data.contentfulProjectPost.title} />
             <h1>
                {props.data.contentfulProjectPost.title}
            </h1>
            <p>{props.data.contentfulProjectPost.createdDate}</p>
            {documentToReactComponents(props.data.contentfulProjectPost.body.json, options)}
            {/* converts contentful data into body */}
        </Layout>
    )
}

export default Proj